import { motion } from "framer-motion";
import { X, Check, Luggage, Globe } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const OLD_WAY = [
  "300 lbs of merch in airline cargo",
  "Excess baggage fees every single leg",
  "Customs declarations and import duty",
  "Lost or delayed stock before the show",
];

const HUB_WAY = [
  "Carry samples only — fly light",
  "Printed locally at your destination",
  "Zero customs, zero cargo fees",
  "Delivered to the venue before doors",
];

export default function Comparison() {
  return (
    <section id="why" data-testid="value-prop-comparison" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: EASE }}
        className="mb-14 max-w-2xl"
      >
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">Why the hub</p>
        <h2 className="font-display text-3xl font-extrabold tracking-tighter sm:text-4xl lg:text-5xl">
          Stop paying to fly <span className="font-serif italic font-medium">t-shirts.</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <motion.div
          data-testid="comparison-old-way"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: EASE }}
          className="border border-zinc-200 bg-white p-8 sm:p-10"
        >
          <div className="flex items-center gap-3">
            <Luggage className="h-5 w-5 text-zinc-400" />
            <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">The old way</h3>
          </div>
          <p className="mt-6 font-display text-2xl font-bold tracking-tight text-zinc-400">Haul it all, everywhere.</p>
          <ul className="mt-8 space-y-4">
            {OLD_WAY.map((item) => (
              <li key={item} className="flex items-start gap-3 text-sm text-zinc-500">
                <X className="mt-0.5 h-4 w-4 shrink-0 text-zinc-300" />
                {item}
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          data-testid="comparison-hub-way"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.12, ease: EASE }}
          className="relative overflow-hidden bg-tour-void p-8 text-white sm:p-10"
        >
          <div className="absolute right-0 top-0 h-24 w-24 bg-tour-red" style={{ clipPath: "polygon(100% 0, 0 0, 100% 100%)" }} />
          <div className="flex items-center gap-3">
            <Globe className="h-5 w-5 text-tour-red" />
            <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-400">The hub way</h3>
          </div>
          <p className="mt-6 font-display text-2xl font-bold tracking-tight">One contact. Print where you play.</p>
          <ul className="mt-8 space-y-4">
            {HUB_WAY.map((item) => (
              <li key={item} className="flex items-start gap-3 text-sm text-zinc-300">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-tour-red" />
                {item}
              </li>
            ))}
          </ul>
          <div className="mt-10 flex gap-8 border-t border-zinc-800 pt-6">
            {[
              ["$0", "cargo fees"],
              ["0", "customs delays"],
              ["48h", "typical local turnaround"],
            ].map(([num, label]) => (
              <div key={label}>
                <p className="font-mono text-2xl font-bold text-white">{num}</p>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-widest text-zinc-500">{label}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
